(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const drawerNav = document.querySelector(".nav-drawer__container");
    const drawerClose = document.querySelector(".nav-drawer__close");
    const drawerOverlay = document.querySelector(".nps-overlay");
    const drawerToggle = document.querySelector(".nav-drawer__toggle");
    const navItemsWithChildren = Array.from(
      document.querySelectorAll(
        ".nav-drawer__item--with-children > .nav-drawer__link, .nav-drawer__item--with-children > .ri-arrow-down-s-line"
      )
    );

    console.log(drawerToggle);

    if (drawerToggle) {
      drawerToggle.addEventListener("click", (e) => {
        e.preventDefault();
        drawerNav.classList.toggle("active");
        drawerOverlay.classList.toggle("active");
      });
    }
    if (drawerClose) {
      drawerClose.addEventListener("click", (e) => {
        e.preventDefault();
        handleClose();
      });
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener("click", () => {
        handleClose();
      });
    }
    if (navItemsWithChildren && navItemsWithChildren.length > 0) {
      navItemsWithChildren.forEach((navItem) => {
        navItem.addEventListener("click", (e) => {
          e.preventDefault();
          navItem.parentElement.classList.toggle("nav-drawer__item--open");
        });
      });
    }

    const handleClose = () => {
      if (drawerNav && drawerOverlay) {
        drawerNav.classList.remove("active");
        drawerOverlay.classList.remove("active");
      }
    };
  });
})();
